import customAxios from './axios';
import CONFIG from '../../config';

export const getAll = (userID) => {
    return customAxios.get(CONFIG.apiURL + `/Noti/GetNotificationsForUser/${userID}`).then(res => {
        let response = res['data'];
        return response;
    }).catch(err => {
        console.log('Get all notifications', err);
    });
};

export const updateToken = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Users/UpdateFcmToken', payload).then(res => {
        let response = res['data'];
        return response;
    }).catch(err => {
        console.log('Update FCM token', err);
    });
};

export const getFlyerNotifications = (payload) => {
    return customAxios.post(CONFIG.apiURL + "/FlyerNoti/GetNotificationsByUser", payload).then((res) => {
        return res["data"];
      }).catch((err) => {
        console.log("Get Flyer Notification", err);
      });
  };
  
export const updateFlyerNotification = (payload) => {
   return customAxios.put(CONFIG.apiURL + "/FlyerNoti/UpdateReadStatus", payload).then((res) => {
       return res["data"];
    }).catch((err) => {
     console.log("Update FlyerNotification Status", err);
    });
};